import {
  faCloudUploadAlt,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import {
  handleClickFile,
  handleClickRemoveFile,
  handleFileChange,
} from "../helpers/handleFiles";

import { placeholderSelectFile } from "../helpers/placeHolders";
import { useState } from "react";

interface IProps {
  formik: any;
  title: string;
  nameFile: string;
  defaultValue: any;
  refInput: any;
  nameProp: string;
}
interface IErrorFile {
  state: boolean;
  text: string;
  reason: string;
}
const initialError: IErrorFile = {
  state: false,
  text: "",
  reason: "",
};

export const InputFile = (props: IProps) => {
  const { formik, title, nameFile, defaultValue, refInput, nameProp } = props;
  const [errorLoad, setErrorLoad] = useState<IErrorFile>(initialError);

  return (
    <>
      <FormGroup>
        <Label>{title}</Label>
        <div className="d-flex input-file-custom">
          <Input
            type="text"
            name={nameFile}
            readOnly
            defaultValue={defaultValue}
            className="form-control cursor-pointer"
            placeholder={placeholderSelectFile()}
            onClick={() => handleClickFile(refInput)}
          />

          {defaultValue !== "" ? (
            <a
              onClick={() =>
                handleClickRemoveFile(`${nameProp}`, formik, refInput)
              }
            >
              <span className="d-md-inline text-danger icon-delete-file">
                <FontAwesomeIcon icon={faTimesCircle} />
              </span>
            </a>
          ) : (
            <a onClick={() => handleClickFile(refInput)}>
              <span className="d-md-inline text-disabled">
                <FontAwesomeIcon
                  className="cursor-pointer"
                  onClick={() => handleClickFile(refInput)}
                  icon={faCloudUploadAlt}
                />
              </span>
            </a>
          )}
        </div>
        <input
          type="file"
          name={`${nameProp}`}
          className="form-control input-file"
          ref={refInput}
          hidden
          onChange={(e) => handleFileChange(e, formik, setErrorLoad)}
        />
        {errorLoad && errorLoad.state && (
          <Row className="mt-3">
            <Col>
              <div className="text-danger" style={{fontSize: '1rem'}}>{errorLoad.text}</div>
            </Col>
          </Row>
        )}
      </FormGroup>
    </>
  );
};
